/* eslint-disable id-length */
import { MOBILE_V1 } from './utils/endpoints';
export default _ref => {
  var shared = _ref.shared,
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? {} : _ref$endpoints;
  var apiClient = shared.apiClient,
    getAbsoluteUrl = shared.getAbsoluteUrl;
  var postWithToken = apiClient.postWithToken;
  var _endpoints$myahEndpoi = endpoints.myahEndpoint,
    myahEndpoint = _endpoints$myahEndpoi === void 0 ? "".concat(MOBILE_V1, "/myah") : _endpoints$myahEndpoi;
  var buildEndpoint = action => "".concat(getAbsoluteUrl(myahEndpoint), "/").concat(action);
  var CHANGE_EMAIL = buildEndpoint('change-email');
  var CHANGE_PASSWORD = buildEndpoint('change-password');
  var UPDATE_DETAILS = buildEndpoint('update-account-details');
  var GET_DETAILS = buildEndpoint('account-details');
  var changeMyahEmail = _ref2 => {
    var email = _ref2.email;
    return postWithToken(CHANGE_EMAIL, {
      newEmail: email
    });
  };
  var changeMyahPassword = _ref3 => {
    var newPassword = _ref3.newPassword,
      currentPassword = _ref3.currentPassword;
    return postWithToken(CHANGE_PASSWORD, {
      newPassword,
      currentPassword
    });
  };
  var updateMyahDetails = _ref4 => {
    var firstName = _ref4.firstName,
      lastName = _ref4.lastName,
      phone = _ref4.phone,
      state = _ref4.state;
    return postWithToken(UPDATE_DETAILS, {
      firstName,
      lastName,
      phone,
      locality: state
    });
  };
  var getMyahDetails = () => postWithToken(GET_DETAILS);
  return {
    changeMyahEmail,
    changeMyahPassword,
    updateMyahDetails,
    getMyahDetails
  };
};